/**
 * om-alt-fix.js
 * ---------------------------------------------------------------------------
 * Names the image-only links that genuinely lack an accessible name.
 *
 * AUDIT RESULT - read this before "fixing" any remaining empty alt.
 * A product page shows 16 images with no alt. Fourteen of those are CORRECT
 * and must be left alone:
 *
 *   5  PDP thumbnails      wrapped in <button aria-label="Show image N">.
 *                          The button carries the name; alt on the image would
 *                          make screen readers announce it twice.
 *   4  cart upsell images  wrapped in <a class="hcx-row__img" aria-hidden="true"
 *                          tabindex="-1">. Deliberately hidden from assistive
 *                          tech because the row's product name is a separate,
 *                          focusable link. Adding alt achieves nothing.
 *   5  card hover images   the second product view, marked aria-hidden.
 *
 * Only 2 were real failures: the "Shop by range" cards, which are image-only
 * links with no text and no label. shopbyrange.liquid does expose an Alt field
 * per block - it has simply been left blank in the theme editor - so the
 * durable fix is to fill those in Customize. This fills them at runtime from
 * the card's own visible label in the meantime.
 *
 * Anything aria-hidden is skipped on purpose.
 */
(function () {
  'use strict';

  if (window.__omAltFixBound) return;
  window.__omAltFixBound = true;

  var TARGETS = ['.range-card__media img'];

  function hiddenFromAT(el) {
    return !!(el.closest && el.closest('[aria-hidden="true"]'));
  }

  function titleFromHref(href) {
    if (!href) return '';
    var m = String(href).match(/\/(?:products|collections)\/([^/?#]+)/);
    if (!m) return '';
    return m[1]
      .replace(/-+\d+$/, '')
      .split('-')
      .filter(Boolean)
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
      .join(' ');
  }

  function nameFor(img) {
    var link = img.closest('a');
    var scope = img.closest('.range-card') || link || img.parentElement;
    if (!scope) return '';

    var candidates = scope.querySelectorAll('.range-card__label, h2, h3, h4, p, span');
    for (var i = 0; i < candidates.length; i++) {
      var t = (candidates[i].textContent || '').trim();
      if (t && t.length > 1 && !/^(rs\.?|₹|\d)/i.test(t)) return t.slice(0, 90);
    }
    return titleFromHref(link && link.getAttribute('href')).slice(0, 90);
  }

  function run() {
    for (var t = 0; t < TARGETS.length; t++) {
      var imgs = document.querySelectorAll(TARGETS[t]);
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (img.getAttribute('alt')) continue;
        if (hiddenFromAT(img)) continue;
        var name = nameFor(img);
        if (name) img.setAttribute('alt', name);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();